import { refresh_token } from "./tokenrefreshNewMethod";
export const verifyToken = async (): Promise<boolean> => {
  try {
    return await refresh_token();
  } catch (error) {
    console.error("Error al verificar el token:", error);
    return false;
  }
};
